'use strict';

import _ from 'lodash';
import { tween } from 'shifty';

export default function() {
  return {
    controller: function($scope, $timeout) {
      'ngInject';

      $scope.num = $scope.element.data.start;

      var t;
      
      function StartTween() {
        if($scope.isVisible) {
          if(t && t.stop) {
            t.stop();
          }
          $scope.num = $scope.element.data.start;
          t = tween({
            from: { x: $scope.element.data.start },
            to: { x: $scope.element.data.end },
            duration: Number($scope.element.data.duration),
            easing: 'easeOutQuad', //$scope.element.data.easing,
            delay: $scope.element.data.delay,
            step: function(state) {
              if(Math.round(state.x) > $scope.num) {
                $scope.num = Math.round(state.x);
                $timeout(function() { });
              }
            }
          }).then(() => {
            $scope.num = $scope.element.data.end;
          });
        }
      }

      $scope.$watch("element.data", StartTween, true);
      $scope.$watch("isVisible", StartTween);
    },
    template: require('./numberSpinner.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/numberSpinner.js